import React from 'react'

import { Outlet } from 'react-router-dom'

import { Grid, CssBaseline, Paper } from '@mui/material'
import { makeStyles } from '@mui/styles'

import Footer from '../../components/Footer'
import Topbar from '../../components/Topbar'

const useStyles = makeStyles(() => {
  const classList = {
    root: {
      height: '100vh'
    }
  }
  return classList
})

const Documentation = () => {
  const classes = useStyles()

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />

      <Grid item component={Paper} elevation={6} square style={{ width: '100vw' }}>
        <Topbar type="auth" />
        <Outlet />
        <Footer />
      </Grid>
    </Grid>

  )
}

export default Documentation
